/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
import { useFormContext } from "react-hook-form";
import { Select } from "@nordcloud/gnui";
import {
  SidebarFormField,
  SidebarFormFieldProps,
} from "~/components/SidebarForm/SidebarFormField";

type Props = {
  name: string;
  options: Option[];
  defaultValue?: string[];
} & SidebarFormFieldProps;

function SidebarMultiSelect(props: Props) {
  const { register, watch, setValue } = useFormContext();

  React.useEffect(() => {
    register({ name: props.name });
  }, [props.name, register]);

  React.useEffect(() => {
    setValue(props.name, props.defaultValue || []);
  }, [setValue, props.name, props.defaultValue]);

  const optionsArray = props.options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  return (
    <SidebarFormField
      label={props.label}
      required={props.required}
      tooltip={props.tooltip}
    >
      <Select
        isMulti
        // @ts-expect-error there is a bug with type generation in GNUI
        onChange={(newValue: any[]) => {
          const mapped = newValue.map((v) => v.value);
          setValue(props.name, mapped);
        }}
        value={optionsArray.filter((opt) =>
          (watch(props.name) || []).includes(opt.value)
        )}
        options={optionsArray}
      />
    </SidebarFormField>
  );
}

export { SidebarMultiSelect };
